import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AdminLayout from './AdminLayout';
import './UserDetails.css';

const UserDetails = () => {
  const navigate = useNavigate();
  const { userId } = useParams();
  const [activeTab, setActiveTab] = useState('bookings');

  // Placeholder user data
  const userData = {
    id: userId || 'USR001',
    name: 'John Doe',
    email: 'john.doe@example.com',
    phone: '+234 801 234 5678',
    status: 'Active',
    registrationDate: '2024-01-15',
    lastLogin: '2024-12-15 14:30'
  };

  // Placeholder bookings data
  const bookings = [
    {
      id: 'SF12345678',
      route: 'Lagos → London',
      date: '2024-12-15',
      amount: '₦850,000',
      status: 'Confirmed'
    },
    {
      id: 'SF12345679',
      route: 'Abuja → Dubai',
      date: '2024-11-20',
      amount: '₦720,000',
      status: 'Completed'
    },
    {
      id: 'SF12345680',
      route: 'Lagos → New York',
      date: '2024-10-10',
      amount: '₦1,250,000',
      status: 'Completed'
    },
    {
      id: 'SF12345681',
      route: 'Port Harcourt → Lagos',
      date: '2024-09-05',
      amount: '₦45,000',
      status: 'Cancelled'
    }
  ];

  // Placeholder payments data
  const payments = [
    {
      id: 'TXN001234',
      method: 'Paystack',
      amount: '₦850,000',
      date: '2024-12-15',
      status: 'Success'
    },
    {
      id: 'TXN001235',
      method: 'Paystack',
      amount: '₦720,000',
      date: '2024-11-20',
      status: 'Success'
    },
    {
      id: 'TXN001236',
      method: 'Bank Transfer',
      amount: '₦1,250,000',
      date: '2024-10-10',
      status: 'Success'
    },
    {
      id: 'TXN001237',
      method: 'Paystack',
      amount: '₦45,000',
      date: '2024-09-05',
      status: 'Failed'
    }
  ];

  // Placeholder support tickets
  const supportTickets = [
    {
      id: 'TKT001',
      subject: 'Flight cancellation request',
      status: 'Open',
      createdDate: '2024-12-10'
    },
    {
      id: 'TKT002',
      subject: 'Baggage inquiry',
      status: 'Resolved',
      createdDate: '2024-11-25'
    },
    {
      id: 'TKT003',
      subject: 'Refund status',
      status: 'In Progress',
      createdDate: '2024-11-15'
    }
  ];

  // Placeholder activity log
  const activityLog = [
    { type: 'login', description: 'User logged in', timestamp: '2024-12-15 14:30' },
    { type: 'booking', description: 'Created booking SF12345678', timestamp: '2024-12-15 14:25' },
    { type: 'password', description: 'Password changed', timestamp: '2024-12-10 10:15' },
    { type: 'login', description: 'User logged in', timestamp: '2024-12-10 09:00' },
    { type: 'booking', description: 'Cancelled booking SF12345681', timestamp: '2024-09-05 16:45' },
    { type: 'login', description: 'User logged in', timestamp: '2024-09-05 16:30' }
  ];

  const handleSuspendUser = () => {
    // Placeholder
    console.log('Suspend/Activate user:', userData.id);
  };

  const handleResetPassword = () => {
    // Placeholder
    console.log('Reset password for user:', userData.id);
  };

  const handleViewBooking = (bookingId) => {
    // Placeholder
    console.log('View booking:', bookingId);
  };

  const handleViewTicket = (ticketId) => {
    // Placeholder
    console.log('View ticket:', ticketId);
  };

  const getActivityIcon = (type) => {
    switch(type) {
      case 'login': return '🔐';
      case 'password': return '🔑';
      case 'booking': return '🎫';
      default: return '📝';
    }
  };

  return (
    <AdminLayout pageTitle="User Details">
      <div className="admin-user-details-page">
        {/* Page Title */}
        <div className="admin-user-details-header">
          <h1 className="admin-user-details-title">User Details</h1>
          <nav className="admin-breadcrumb">
            <button 
              className="admin-breadcrumb-link"
              onClick={() => navigate('/admin/users')}
            >
              Users
            </button>
            <span className="admin-breadcrumb-separator">→</span>
            <span className="admin-breadcrumb-current">User Details</span>
          </nav>
        </div>

        {/* User Summary Card */}
        <div className="admin-user-summary-card">
          <div className="admin-user-summary-content">
            <div className="admin-user-summary-info">
              <div className="admin-user-summary-row">
                <div className="admin-user-summary-item">
                  <label className="admin-user-summary-label">Full Name</label>
                  <div className="admin-user-summary-value">{userData.name}</div>
                </div>
                <div className="admin-user-summary-item">
                  <label className="admin-user-summary-label">Email</label>
                  <div className="admin-user-summary-value">{userData.email}</div>
                </div>
              </div>
              <div className="admin-user-summary-row">
                <div className="admin-user-summary-item">
                  <label className="admin-user-summary-label">Phone</label>
                  <div className="admin-user-summary-value">{userData.phone}</div>
                </div>
                <div className="admin-user-summary-item">
                  <label className="admin-user-summary-label">Account Status</label>
                  <div className="admin-user-summary-value">
                    <span className={`admin-status-badge admin-status-${userData.status.toLowerCase()}`}>
                      {userData.status}
                    </span>
                  </div>
                </div>
              </div>
              <div className="admin-user-summary-row">
                <div className="admin-user-summary-item">
                  <label className="admin-user-summary-label">Registration Date</label>
                  <div className="admin-user-summary-value">{userData.registrationDate}</div>
                </div>
                <div className="admin-user-summary-item">
                  <label className="admin-user-summary-label">Last Login</label>
                  <div className="admin-user-summary-value">{userData.lastLogin}</div>
                </div>
              </div>
            </div>
            <div className="admin-user-summary-actions">
              <button
                className="admin-summary-action-button"
                onClick={handleSuspendUser}
              >
                {userData.status === 'Active' ? 'Suspend User' : 'Activate User'}
              </button>
              <button
                className="admin-summary-action-button"
                onClick={handleResetPassword}
              >
                Reset Password
              </button>
            </div>
          </div>
        </div>

        {/* Tabbed Section */}
        <div className="admin-tabs-section">
          {/* Desktop Tabs */}
          <div className="admin-tabs-desktop">
            <div className="admin-tabs-list">
              <button
                className={`admin-tab ${activeTab === 'bookings' ? 'active' : ''}`}
                onClick={() => setActiveTab('bookings')}
              >
                Bookings
              </button>
              <button
                className={`admin-tab ${activeTab === 'payments' ? 'active' : ''}`}
                onClick={() => setActiveTab('payments')}
              >
                Payments
              </button>
              <button
                className={`admin-tab ${activeTab === 'tickets' ? 'active' : ''}`}
                onClick={() => setActiveTab('tickets')}
              >
                Support Tickets
              </button>
              <button
                className={`admin-tab ${activeTab === 'activity' ? 'active' : ''}`}
                onClick={() => setActiveTab('activity')}
              >
                Activity Log
              </button>
            </div>
          </div>

          {/* Mobile Tab Dropdown */}
          <div className="admin-tabs-mobile">
            <select
              className="admin-tabs-select"
              value={activeTab}
              onChange={(e) => setActiveTab(e.target.value)}
            >
              <option value="bookings">Bookings</option>
              <option value="payments">Payments</option>
              <option value="tickets">Support Tickets</option>
              <option value="activity">Activity Log</option>
            </select>
          </div>

          {/* Tab Content */}
          <div className="admin-tab-content">
            {/* Bookings Tab */}
            {activeTab === 'bookings' && (
              <div className="admin-tab-panel">
                <div className="admin-table-card">
                  <div className="admin-table-wrapper">
                    <table className="admin-details-table">
                      <thead>
                        <tr>
                          <th>Booking ID</th>
                          <th>Route</th>
                          <th>Date</th>
                          <th>Amount</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {bookings.map((booking) => (
                          <tr key={booking.id} className="admin-table-row">
                            <td className="admin-table-cell admin-table-id">{booking.id}</td>
                            <td className="admin-table-cell">{booking.route}</td>
                            <td className="admin-table-cell">{booking.date}</td>
                            <td className="admin-table-cell admin-table-amount">{booking.amount}</td>
                            <td className="admin-table-cell">
                              <span className={`admin-status-badge admin-status-${booking.status.toLowerCase()}`}>
                                {booking.status}
                              </span>
                            </td>
                            <td className="admin-table-cell">
                              <button
                                className="admin-table-action"
                                onClick={() => handleViewBooking(booking.id)}
                              >
                                View Booking
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Mobile Card View */}
                <div className="admin-details-cards">
                  {bookings.map((booking) => (
                    <div key={booking.id} className="admin-detail-card">
                      <div className="admin-detail-card-header">
                        <div className="admin-detail-card-id">{booking.id}</div>
                        <span className={`admin-status-badge admin-status-${booking.status.toLowerCase()}`}>
                          {booking.status}
                        </span>
                      </div>
                      <div className="admin-detail-card-body">
                        <div className="admin-detail-card-row">
                          <span className="admin-detail-card-label">Route:</span>
                          <span className="admin-detail-card-value">{booking.route}</span>
                        </div>
                        <div className="admin-detail-card-row">
                          <span className="admin-detail-card-label">Date:</span>
                          <span className="admin-detail-card-value">{booking.date}</span>
                        </div>
                        <div className="admin-detail-card-row">
                          <span className="admin-detail-card-label">Amount:</span>
                          <span className="admin-detail-card-value">{booking.amount}</span>
                        </div>
                      </div>
                      <div className="admin-detail-card-actions">
                        <button
                          className="admin-detail-card-button"
                          onClick={() => handleViewBooking(booking.id)}
                        >
                          View Booking
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Payments Tab */}
            {activeTab === 'payments' && (
              <div className="admin-tab-panel">
                <div className="admin-table-card">
                  <div className="admin-table-wrapper">
                    <table className="admin-details-table">
                      <thead>
                        <tr>
                          <th>Transaction ID</th>
                          <th>Payment Method</th>
                          <th>Amount</th>
                          <th>Date</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {payments.map((payment) => (
                          <tr key={payment.id} className="admin-table-row">
                            <td className="admin-table-cell admin-table-id">{payment.id}</td>
                            <td className="admin-table-cell">{payment.method}</td>
                            <td className="admin-table-cell admin-table-amount">{payment.amount}</td>
                            <td className="admin-table-cell">{payment.date}</td>
                            <td className="admin-table-cell">
                              <span className={`admin-status-badge admin-status-${payment.status.toLowerCase()}`}>
                                {payment.status}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Mobile Card View */}
                <div className="admin-details-cards">
                  {payments.map((payment) => (
                    <div key={payment.id} className="admin-detail-card">
                      <div className="admin-detail-card-header">
                        <div className="admin-detail-card-id">{payment.id}</div>
                        <span className={`admin-status-badge admin-status-${payment.status.toLowerCase()}`}>
                          {payment.status}
                        </span>
                      </div>
                      <div className="admin-detail-card-body">
                        <div className="admin-detail-card-row">
                          <span className="admin-detail-card-label">Method:</span>
                          <span className="admin-detail-card-value">{payment.method}</span>
                        </div>
                        <div className="admin-detail-card-row">
                          <span className="admin-detail-card-label">Amount:</span>
                          <span className="admin-detail-card-value">{payment.amount}</span>
                        </div>
                        <div className="admin-detail-card-row">
                          <span className="admin-detail-card-label">Date:</span>
                          <span className="admin-detail-card-value">{payment.date}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Support Tickets Tab */}
            {activeTab === 'tickets' && (
              <div className="admin-tab-panel">
                <div className="admin-table-card">
                  <div className="admin-table-wrapper">
                    <table className="admin-details-table">
                      <thead>
                        <tr>
                          <th>Ticket ID</th>
                          <th>Subject</th>
                          <th>Status</th>
                          <th>Created Date</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {supportTickets.map((ticket) => (
                          <tr key={ticket.id} className="admin-table-row">
                            <td className="admin-table-cell admin-table-id">{ticket.id}</td>
                            <td className="admin-table-cell">{ticket.subject}</td>
                            <td className="admin-table-cell">
                              <span className={`admin-status-badge admin-status-${ticket.status.toLowerCase().replace(' ', '-')}`}>
                                {ticket.status}
                              </span>
                            </td>
                            <td className="admin-table-cell">{ticket.createdDate}</td>
                            <td className="admin-table-cell">
                              <button
                                className="admin-table-action"
                                onClick={() => handleViewTicket(ticket.id)}
                              >
                                View Ticket
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Mobile Card View */}
                <div className="admin-details-cards">
                  {supportTickets.map((ticket) => (
                    <div key={ticket.id} className="admin-detail-card">
                      <div className="admin-detail-card-header">
                        <div className="admin-detail-card-id">{ticket.id}</div>
                        <span className={`admin-status-badge admin-status-${ticket.status.toLowerCase().replace(' ', '-')}`}>
                          {ticket.status}
                        </span>
                      </div>
                      <div className="admin-detail-card-body">
                        <div className="admin-detail-card-row">
                          <span className="admin-detail-card-label">Subject:</span>
                          <span className="admin-detail-card-value">{ticket.subject}</span>
                        </div>
                        <div className="admin-detail-card-row">
                          <span className="admin-detail-card-label">Created:</span>
                          <span className="admin-detail-card-value">{ticket.createdDate}</span>
                        </div>
                      </div>
                      <div className="admin-detail-card-actions">
                        <button
                          className="admin-detail-card-button"
                          onClick={() => handleViewTicket(ticket.id)}
                        >
                          View Ticket
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Activity Log Tab */}
            {activeTab === 'activity' && (
              <div className="admin-tab-panel">
                <div className="admin-activity-log">
                  {activityLog.map((activity, index) => (
                    <div key={index} className="admin-activity-item">
                      <div className="admin-activity-icon">{getActivityIcon(activity.type)}</div>
                      <div className="admin-activity-content">
                        <div className="admin-activity-description">{activity.description}</div>
                        <div className="admin-activity-timestamp">{activity.timestamp}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default UserDetails;

